import { PayloadAction } from "@reduxjs/toolkit";

import { StationsState } from '../../types';

export const setFilteredStationsFilter = (
  state: StationsState,
  action: PayloadAction<StationsState['filteredStations']['filter']>
) => {
  state.filteredStations.filter = action.payload;
};
